/**
 * `?error=<code>` on the pages a failed sign-in lands on. Better Auth sends a sign-in that
 * fails mid-redirect (an SSO callback) back with its own code; the app guard adds
 * `account_disabled` when a live session's membership or organisation was disabled.
 */
import { IDENTITY_MESSAGES, type MessageRef, msg } from '@daka/core';
import { z } from 'zod';

export const ACCOUNT_DISABLED = 'account_disabled';

export const authErrorSearch = z.object({ error: z.string().max(100).optional().catch(undefined) });

/** What the sign-in page says for an `?error=` code. */
export function authErrorMessage(code: string): MessageRef {
   return code === ACCOUNT_DISABLED ? msg(IDENTITY_MESSAGES.accountDisabled) : msg(IDENTITY_MESSAGES.signInFailed, { code });
}
